import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class RecalculateFormulaService {
	public recalculateFormula$: Observable<boolean>;
	private recalculateFormula: BehaviorSubject<boolean>;

	public constructor() {
		this.recalculateFormula = new BehaviorSubject(false);
		this.recalculateFormula$ = this.recalculateFormula.asObservable();
	}

	public refreshFormulaValue(shouldRefreshFormula: boolean) {
		this.recalculateFormula.next(shouldRefreshFormula);
	}
}
